(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["evendy-assortment"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('evendy-assortment')) customElements.define('evendy-assortment', class extends HTMLElement {
 connectedCallback() {
  if (this.dataset.ready) return; this.dataset.ready = 'true';
  const buttons = [...this.querySelectorAll('[data-ev-filter]')];
  const items = [...this.querySelectorAll('[data-ev-category]')];
  const filter = category => {
   buttons.forEach(button => button.setAttribute('aria-pressed',String(button.dataset.evFilter === category)));
   items.forEach(item => item.hidden = category !== 'all' && item.dataset.evCategory !== category);
   this.querySelector('[data-ev-count]').textContent = items.filter(item => !item.hidden).length;
  };
  buttons.forEach(button => button.addEventListener('click',() => filter(button.dataset.evFilter)));
  filter('all');
 }
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["evendy-contact"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('click', event => {
 const link = event.target.closest('[data-ev-location], [data-ev-interest]');
 if (!link) return;
 const kind = link.hasAttribute('data-ev-location') ? 'location' : 'interest';
 const key = link.getAttribute('data-ev-' + kind);
 const select = document.querySelector('[data-ev-' + kind + '-select]');
 const option = select?.querySelector('[data-' + kind + '="' + key + '"]');
 if (select && option) { select.value = option.value; select.dispatchEvent(new Event('change', {bubbles:true})); }
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["evendy-header"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('click', (event) => {
  const menuLink = event.target.closest('.ev-mobile-menu a');
  if (menuLink) menuLink.closest('details').open = false;
});
document.addEventListener('keydown', (event) => {
  if (event.key === 'Escape') document.querySelectorAll('.ev-mobile-menu[open]').forEach(menu => { menu.open = false; menu.querySelector('summary').focus(); });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["evendy-locations"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('evendy-locations')) customElements.define('evendy-locations', class extends HTMLElement {
 connectedCallback() {
  if (this.dataset.ready) return;
  this.dataset.ready = 'true';
  const tabs = [...this.querySelectorAll('[data-ev-tab]')];
  const panels = [...this.querySelectorAll('[data-ev-panel]')];
  tabs.forEach(tab => { if (!panels.some(panel => panel.dataset.evPanel === tab.dataset.evTab)) tab.hidden = true; });
  const active = tabs.filter(tab => !tab.hidden);
  this.querySelector('[data-ev-tabs]').setAttribute('role','tablist');
  active.forEach(tab => tab.setAttribute('role','tab'));
  panels.forEach(panel => { panel.setAttribute('role','tabpanel'); panel.tabIndex = 0; });
  const select = (key, focus = false) => {
    active.forEach(tab => { const selected = tab.dataset.evTab === key; tab.setAttribute('aria-selected', String(selected)); tab.tabIndex = selected ? 0 : -1; if (selected && focus) tab.focus(); });
    panels.forEach(panel => panel.hidden = panel.dataset.evPanel !== key);
  };
  active.forEach((tab, index) => {
   tab.addEventListener('click', () => select(tab.dataset.evTab));
   tab.addEventListener('keydown', event => {
    let next = index;
    if (event.key === 'ArrowRight') next = (index + 1) % active.length;
    else if (event.key === 'ArrowLeft') next = (index + active.length - 1) % active.length;
    else if (event.key === 'Home') next = 0;
    else if (event.key === 'End') next = active.length - 1;
    else return;
    event.preventDefault(); select(active[next].dataset.evTab, true);
   });
  });
  if (active[0]) select(active[0].dataset.evTab);
  this.addEventListener('shopify:block:select', event => { const panel = event.target.closest('[data-ev-panel]'); if (panel) select(panel.dataset.evPanel); });
 }
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
